

const LOCATIONS_URL = "/locations";
const TOWER_STAGE = "/towerStages"
const TOWER_STAGE_LEVELS_URL = "/towerStageLevels"

export default {
  state: {
    locations: [],
    selectedLocation: {},
    urlImageLocation: "",
    loading: true,
    //add data lvls torres
    selectedLevel: {},
    selectedDtp: { id: 0 },
    aa: {},
  },
  mutations: {
    _setLocations(state, data) {
      state.locations = data;
    },
    _clearCoords(state) {
      state.locations = [];
    },
    _selectedLocation(state, location) {
      state.selectedLocation = location;
    },
    _setAvailableImageLocation(state, urlImageLocation) {
      state.urlImageLocation = urlImageLocation;
    },
    _setLoading(state, stateLoading) {
      state.loading = stateLoading;
    },
    //add data lvls torres
    _selectedLevel(state, location) {
      state.selectedLevel = location;
    },
    _selectedDpt(state, location) {
      state.selectedDpt = location;
    },
    _selectedA(state, location) {
      state.aa = location;
    },
    _clearLevels(state) {
      state.selectedLevel = [];
    },
    _clearDpt(state) {
      state.selectedDpt = [];
    }, //
  },
  getters: {
    getLocations: (state) => {
      return state.locations;
    },
    getSelectedLocation: (state) => {
      return state.selectedLocation;
    },
    getUrlImageLocation: (state) => {
      return state.urlImageLocation;
    },
    getStatusLoading: (state) => {
      return state.loading;
    },
    //add data lvls torres
    getSelectedLevel: (state) => {
      return state.selectedLevel;
    },
    getStatusDpt: (state) => {
      return state.selectedDpt;
    },
    getStatusA: (state) => {
      return state.aa;
    },
  },
  actions: {
    async getTotAvailableLocations(context, development) {
      try {
        // 1. Construir la URL principal
        let AVAILABLE_LOCATIONS_URL = `${LOCATIONS_URL}/availability/${development.id}?towerId=${development.level}`;

        // 2. Inicializar arreglo para la data combinada
        let combinedData = [];
        let totAvailable = 0;

        // 3. Consumir el endpoint principal
        let responseMain = await context.rootGetters.api.get(
          AVAILABLE_LOCATIONS_URL,
        );

        // Mapear la respuesta principal con la misma estructura
        let mainArr = responseMain.data.map((response_obj) => {
          let obj = {
            id: response_obj.locationId,
            name: response_obj.locationName,
            available: response_obj.available,
            price: response_obj.value,
            side: response_obj.locationName.includes("B") ? "DER" : "IZQ",
          };

          // Lógica para calcular `totAvailable`
          if (response_obj.statusLocationID === 2) {
            totAvailable += 1; // Incrementar totAvailable si el estado es 2
          }

          return obj;
        });

        // 4. Unir los resultados en combinedData
        combinedData = combinedData.concat(mainArr);

        // 5. Agregar las nuevas claves al objeto development
        development.combinedData = combinedData;
        development.totAvailable = totAvailable;

        // console.log(`Development actualizado: ${JSON.stringify(development)}`);
        return development;
      } catch (e) {
        console.error(e);

        // En caso de error, agregar claves vacías al objeto development
        development.combinedData = [];
        development.totAvailable = 0;

        return development;
      }
    },
    async getAvailableLocations(context, development) {
      try {
        // 1. Construir la URL principal
        let AVAILABLE_LOCATIONS_URL = `${LOCATIONS_URL}/availability/${development.id}`;

        // Si el nivel (development.level) es mayor a 0, incluimos ?towerId
        if (development.level > 0) {
          AVAILABLE_LOCATIONS_URL += `?towerId=${development.level}`;
        }

        // 2. Inicializar arreglo para la data combinada
        let combinedData = [];

        // 3. Verificar la condición para el endpoint auxiliar
        //    En este caso: si (development.aux !== 0 && development.aux === 236)
        if (development.aux !== 0 && (development.aux === 236 || development.aux === 310)) {
          // Construir la URL para el endpoint auxiliar
          let AUX_LOCATIONS_URL = `${LOCATIONS_URL}/availability/${development.id}?towerId=${development.aux}`;

          // Consumir el endpoint auxiliar
          let responseAux = await context.rootGetters.api.get(
            AUX_LOCATIONS_URL,
          );

          // Mapeamos la respuesta auxiliar con exactamente los mismos campos y lógica
          let auxArr = responseAux.data.map((item) => {
            let obj = {};
            obj.id = item.locationId;
            obj.projectId = Number(development.id);
            obj.name = item.locationName;
            obj.type = item.prototypeName;
            obj.status = item.statusLocationID;
            obj.m2c = item.m2c;
            obj.coords = item.coordinates;
            obj.shape = item.shape;
            obj.m2t = item.m2t;
            obj.value = item.value;
            obj.totalMeters2 = item.totalMeters2;
            obj.available = item.available;
            obj.reserved = item.reserved;
            obj.imagePrototype = item.imagePrototype;
            obj.unavailable = item.unavailable;

            // Lógica para color y statusText en base a statusLocationID
            switch (item.statusLocationID) {
              case 2:
                obj.color = "31af67";
                obj.statusText = "Disponible";
                break;
              case 3:
                obj.color = "FAF142";
                obj.statusText = "Reservado";
                break;
              case 4:
                obj.color = "B00000";
                obj.status = 0;
                obj.statusText = "Vendido";
                break;
              default:
                obj.status = 4;
                obj.color = "5C5656";
                obj.statusText = "Bloqueado";
                break;
            }
            
            return obj;
          });

          // Combinamos estos resultados con el arreglo principal
          combinedData = combinedData.concat(auxArr);
        }

        // 4. Consumir el endpoint principal
        let responseMain = await context.rootGetters.api.get(
          AVAILABLE_LOCATIONS_URL,
        );

        // Mapeamos la respuesta principal con la misma estructura
        let mainArr = responseMain.data.map((response_obj) => {
          let obj = {};
          obj.id = response_obj.locationId;
          obj.projectId = Number(development.id);
          obj.name = response_obj.locationName;
          obj.type = response_obj.prototypeName;
          obj.status = response_obj.statusLocationID;
          obj.m2c = response_obj.m2c;
          obj.coords = response_obj.coordinates;
          obj.shape = response_obj.shape;
          obj.m2t = response_obj.m2t;
          obj.value = response_obj.value;
          obj.totalMeters2 = response_obj.totalMeters2;
          obj.available = response_obj.available;
          obj.reserved = response_obj.reserved;
          obj.imagePrototype = response_obj.imagePrototype;
          obj.unavailable = response_obj.unavailable;

          // Lógica para color y statusText
          switch (response_obj.statusLocationID) {
            case 2:
              obj.color = "31af67";
              obj.statusText = "Disponible";
              break;
            case 3:
              obj.color = "FAF142";
              obj.statusText = "Reservado";
              break;
            case 4:
              obj.color = "B00000";
              obj.status = 0;
              obj.statusText = "Vendido";
              break;
            default:
              obj.status = 4;
              obj.color = "5C5656";
              obj.statusText = "Bloqueado";
              break;
          }

          return obj;
        });

        // 5. Unir los resultados en combinedData
        combinedData = combinedData.concat(mainArr);

        // 6. Hacer el commit en Vuex
        await context.commit("_setLocations", combinedData);

        // 7. (Opcional) Mostrar en consola
        // console.log("Este es el console log", combinedData);
        return combinedData;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    async getTowerStageLevels(context, development) {
      let AVAILABLE_TOWERS_URL = `${TOWER_STAGE_LEVELS_URL}/${development.id}`;
      if (development.level > 0) {
        AVAILABLE_TOWERS_URL += `?towerStageLevelId=${development.level}`;
      }
      let response = await context.rootGetters.api.get(
        `${AVAILABLE_TOWERS_URL}`,
      );
      let arr = [];
      for (let i = 0; i < response.data.length; i++) {
        let obj = {};
        let response_obj = response.data[i];
        obj.id = response_obj.id;
        obj.type = response_obj.prototypeName;
        obj.name = response_obj.description;
        obj.coords = response_obj.coordinates;
        obj.coords_mini_der = response_obj.coordinates_mini_der;
        obj.coords_mini_izq = response_obj.coordinates_mini_izq;
        obj.lado = response_obj.side;
        obj.reserved = response_obj.reserved;
        obj.type = response_obj.prototypeName;
        obj.unavailable = response_obj.unavailable;
        obj.shape = "poly";
        obj.m2t = response_obj.m2t;
        if (development.id == "55" || development.id == "54") {
          const tot = await context.dispatch("getTotAvailableLocations", {
            id: 48,
            level: response_obj.id,
          });
          const match = tot.combinedData.find(
            (item) => item.side === response_obj.side,
          );
          if (match) {
            obj.available = match.available;
          }
        } else if (
          //Departamentos de cañadas desarrollo 35
          development.id == 87 ||
          development.id == 88 ||
          development.id == 90 ||
          development.id == 91 ||
          development.id == 94 ||
          development.id == 96 ||
          development.id == 97 ||
          development.id == 98 ||
          development.id == 99
        ) {
          const tot = await context.dispatch("getTotAvailableLocations", {
            id: 35,
            level: response_obj.id,
          });
          obj.pricesList = tot.combinedData
            .map((item) => item.price)
            .filter((price) => typeof price === "number" && price > 0);
          obj.available = response_obj.available;
        } else {
          obj.available = response_obj.available;
        }
        if (obj.available == 0) {
          if (response_obj.reserved == 0) {
            obj.color = "B00000";
          } else {
            obj.color = "FAF142";
          }
          if (development.id == 29 || development.id == 51) {
            obj.color = "454141";
          } else {
            obj.color = "CB3234";
          }
        } else {
          obj.color = "31af67";
        }
        arr.push(obj);
      }
      context.commit("_setLocations", arr);
      return arr;
    },
    async getTowerStage(context, development) {
      let AVAILABLE_TOWERS_URL = `/financial${TOWER_STAGE}/?projectId=${development.id}`;
      let response = await context.rootGetters.api.get(
        `${AVAILABLE_TOWERS_URL}`,
      );
      let arr = [];
      for (let i = 0; i < response.data.length; i++) {
        let obj = {};
        let response_obj = response.data[i];
        obj.id = response_obj.id;
        obj.name = response_obj.name;
        obj.type = response_obj.prototypeName;
        obj.coords = response_obj.coordinates;
        obj.reserved = response_obj.reserved;
        obj.type = response_obj.prototypeName;
        obj.unavailable = response_obj.unavailable;
        obj.shape = "poly";
        obj.m2t = response_obj.m2t;
        obj.available = response_obj.available;
        if (response_obj.available == 0) {
          if (response_obj.reserved == 0) {
            obj.color = "B00000";
            obj.status = 0;
          } else {
            obj.color = "FAF142";
          }
          obj.color = "CB3234";
        } else {
          obj.color = "31af67";
        }
        arr.push(obj);
      }
      context.commit("_setLocations", arr);
    },
    async getAvailableImageLocation(context, development) {
      context.dispatch("getLoading", true);
      context.commit("_setAvailableImageLocation", "");
      /* console.log( `${LOCATIONS_URL}/image/${development.id}`) */
      try {
        let AVAILABLE_IMAGE_LOCATION = `${LOCATIONS_URL}/image/${development.id}`;
        let response = await context.rootGetters.api.get(
          `${AVAILABLE_IMAGE_LOCATION}`,
        );
        context.commit("_setAvailableImageLocation", response.data);
      } catch (e) {
        console.log(e);
      } finally {
        context.dispatch("getLoading", false);
      }
    },

    async getLoading(context, stateLoading) {
      context.commit("_setLoading", stateLoading);
    },
    selectedLocation(context, location) {
      context.commit("_selectedLocation", location);
    },
    async clearCoords(context) {
      await context.commit("_clearCoords");
    },
    //add data lvls torres
    async getAvailableLevels(context, development) {
      try {
        let AVAILABLE_LOCATIONS_URL = `${LOCATIONS_URL}/availability/${development.id}`;
        if (development.level > 0) {
          AVAILABLE_LOCATIONS_URL += `?towerId=${development.level}`;
        }
        let response = await context.rootGetters.api.get(
          `${AVAILABLE_LOCATIONS_URL}`,
        );
        let arr = [];
        for (let i = 0; i < response.data.length; i++) {
          let obj = {};
          let response_obj = response.data[i];
          obj.id = response_obj.locationId;
          obj.projectId = Number(development.id);
          obj.name = response_obj.locationName;
          obj.type = response_obj.prototypeName;
          obj.status = response_obj.statusLocationID;
          obj.m2c = response_obj.m2c;
          obj.coords = response_obj.coordinates;
          obj.shape = response_obj.shape;
          obj.m2t = response_obj.m2t;
          obj.value = response_obj.value;
          obj.totalMeters2 = response_obj.totalMeters2;
          obj.available = response_obj.available;
          obj.reserved = response_obj.reserved;
          obj.imagePrototype = response_obj.imagePrototype;
          obj.unavailable = response_obj.unavailable;
          if (response_obj.statusLocationID == 2) {
            obj.color = "31af67";
            obj.statusText = "Disponible";
          } else if (response_obj.statusLocationID == 3) {
            obj.color = "FAF142";
            obj.statusText = "Reservado";
          } else if (response_obj.statusLocationID == 4) {
            obj.color = "B00000";
            obj.status = 0;
            obj.statusText = "Vendido";
          } else {
            obj.status = 4;
            obj.color = "5C5656";
            obj.statusText = "Bloqueado";
          }
          obj.m2t = response_obj.m2t;
          arr.push(obj);
        }
        context.commit("_selectedLevel", arr);
      } catch (e) {
        console.log(e);
      }
    },
    getSelectedDpts(context, department) {
      context.commit("_selectedDpt", department);
      //for update
      context.commit("_selectedA", department);
    },
    async clearLevels(context) {
      await context.commit(" _clearLevels");
    },
    async clearDpt(context) {
      await context.commit("_clearDpt");
    },
  },
};
